<template>
  <div class="PersonelDayWork">
    <section-personel-search-panel :accessTo="14" @search="search" />
    <box class="mt-2" :title="$t('functionalityList')">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length > 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div v-if="list.length > 0">
        <div class="pa-1">
          <v-row>
            <v-col cols="12" sm="6">
              <div class="d-flex pa-1">
                <div class="red color-box"></div>
                <span class="px-1">غیبت</span>
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="d-flex pa-1">
                <div class="green color-box"></div>
                <span class="px-1">روز های تعطیل رسمی یا تعطیل توافقی</span>
              </div>
            </v-col>
          </v-row>
        </div>
        <list-item-daily-functionality-web
          :list="list"
          class="hidden-sm-and-down"
        />
        <list-item-daily-functionality-app
          :list="list"
          class="hidden-md-and-up"
        />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>

    <daily-functionality-summary :totalPersonDayWork="totalPersonDayWork" />
  </div>
</template>

<script>
import DailyFunctionalitySummary from "../../components/functionality/daily/DailyFunctionalitySummary.vue";
import ListItemDailyFunctionalityApp from "../../components/functionality/daily/ListItemDailyFunctionalityApp.vue";
import ListItemDailyFunctionalityWeb from "../../components/functionality/daily/ListItemDailyFunctionalityWeb.vue";
import SectionPersonelSearchPanel from "../../components/personelOperationReport/SectionPersonelSearchPanel.vue";
import EmptyList from "../../components/widget/EmptyList.vue";
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  components: {
    SectionPersonelSearchPanel,
    ListItemDailyFunctionalityWeb,
    ListItemDailyFunctionalityApp,
    DailyFunctionalitySummary,
    EmptyList,
  },
  data() {
    return {
      list: [],
      totalPersonDayWork: {},
      visiblePrint: false,
      beginDate: "",
      endDate: "",
      perno: "",
    };
  },
  methods: {
    search(searchParams) {
      this.beginDate = searchParams.beginDate;
      this.endDate = searchParams.endDate;
      this.perno = searchParams.perno;

      var params = searchParams;
      this.$store
        .dispatch("getPersonDayWorksTotal", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            var dailyList = result.data.WebPersonDayWorks.WebWorkDayList;
            this.list = dailyList;
            this.totalPersonDayWork = result.data.TotallPersonDayWork;
            if (dailyList.length == 0) {
              this.emptyList = true;
            }
            this.checkVisiblePrint();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var canPrint = false;

        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            canPrint = true;
            return false;
          }
          return true;
        });

        if (!canPrint) {
          var permission = this.$store.state.personel.personelDetail.Permission;
          console.log(permission[19]);
          if (permission[19].toString() == "1") {
            this.visiblePrint = true;
          }
        }
      }
    },
    print() {
      var dp = this.perno
      let routeData = this.$router.resolve({
        name: "rpPersonelsDayWork",
        query: { BD: this.beginDate, ED: this.endDate, dp: dp },
      });
      window.open(routeData.href, "_blank");
    },
    onClick() {},
  },
};
</script>

<style>
</style>